export default () => ({
	open: false,
	variant_id: null,
	variant_title: '',
	bis_form: document.querySelector('.klaviyo-bis-required'),
	marketing: document.querySelector('.klaviyo-bis'),

	openBis(event) {
		this.variant_id = event.detail.id;
		this.variant_title = event.detail.title;
		setTimeout(() => {
			this.addVariantTitle();
			this.open = true;
		}, 250);
	},

	closeBis() {
		this.open = false;
		this.removeVariantTitle();
	},

	addVariantTitle() {
		const heading = this.bis_form.querySelector('h1');
		if (heading) {
			const variant_title = `<span class="bis__variant-title">${this.variant_title}</span>`;
			heading.insertAdjacentHTML('afterend', variant_title);
		}
	},

	removeVariantTitle() {
		const variant_title = document.querySelector('.bis__variant-title');
		if (variant_title) {
			variant_title.remove();
		}
	},

	async initBis(email) {
		const url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=RUuy5Q';
		const payload = {
			data: {
				type: 'back-in-stock-subscription',
				attributes: {
					profile: {
						data: {
							type: 'profile',
							attributes: {
								email: `${email}`,
							},
						},
					},
					channels: ['EMAIL'],
				},
				relationships: {
					variant: {
						data: {
							type: 'catalog-variant',
							id: `$shopify:::$default:::${this.variant_id}`,
						},
					},
				},
			},
		};
		const requestOptions = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				revision: '2023-12-15',
			},
			body: JSON.stringify(payload),
		};

		const response = await fetch(url, requestOptions);
		if (response.ok) {
			setTimeout(() => {
				this.closeBis();
			}, 2500);
		}
	},

	init() {
		window.addEventListener('klaviyoForms', async (e) => {
			if (e.detail.type === 'submit' && e.detail.formId === 'WJEaBM') {
				const email = e.detail.metaData.$email;
				await this.initBis(email);
			}
		});
	},
});
